<template>
  <v-app>
    <referring-agent-header></referring-agent-header>
    <v-main style="padding:0px!important;margin-top: 70px;">
      <v-container style="margin-top:40px;margin-bottom: 72px;">
        
        <!-- Page Header -->
        <v-row class="mb-6">
          <v-col cols="12">
            <div class="text-center">
              <h1 class="text-h3 font-weight-bold text-typo mb-2">My Referrals</h1>
              <p class="text-subtitle-1 grey--text">Share your referral link and earn rewards!</p>
            </div>
          </v-col>
        </v-row>

        <!-- Referral Link Card -->
        <v-card class="card-shadow border-radius-xl mb-6" elevation="4">
          <div class="px-6 py-6">
            <h5 class="text-h5 font-weight-bold text-typo mb-4">
              <v-icon color="orange" class="mr-2">mdi-link</v-icon>
              Your Referral Link
            </h5>
            <p class="text-subtitle-2 grey--text mb-4">
              Share this link with friends and family. You'll earn rewards when they sign up or enter sweepstakes!
            </p>
          </div>
          
          <div class="px-6 pb-6 pt-0">
            <v-text-field
              :value="referralLink"
              label="Your Personal Referral Link"
              readonly
              outlined
              append-icon="fa fa-copy"
              @click:append="copyReferralLink"
              class="font-size-input input-style"
              hint="Click the copy icon to copy your link"
              persistent-hint
            >
            </v-text-field>
            
            <!-- Quick Share Buttons -->
            <div class="text-center mt-4">
              <v-btn
                color="blue"
                dark
                class="mr-2 mb-2"
                @click="shareOnFacebook"
              >
                <v-icon left class="material-icons-round">facebook</v-icon>
                Facebook
              </v-btn>
              
              <v-btn
                color="light-blue"
                dark
                class="mr-2 mb-2"
                @click="shareOnTwitter"
              >
                <v-icon left class="material-icons-round">share</v-icon>
                Twitter
              </v-btn>
              
              <v-btn
                color="green"
                dark
                class="mr-2 mb-2"
                @click="shareViaSMS"
              >
                <v-icon left class="material-icons-round">message</v-icon>
                SMS
              </v-btn>
              
              <v-btn
                color="red"
                dark
                class="mr-2 mb-2"
                @click="shareViaEmail"
              >
                <v-icon left class="material-icons-round">email</v-icon>
                Email
              </v-btn>
            </div>
          </div>
        </v-card>

        <!-- Referral Statistics -->
        <v-card class="card-shadow border-radius-xl mb-6" elevation="4">
          <div class="px-6 py-6">
            <h5 class="text-h5 font-weight-bold text-typo mb-4">
              Your Referral Statistics
            </h5>
          </div>
          
          <div class="px-6 pb-6 pt-0">
            <v-row>
              <v-col cols="12" sm="6">
                <div class="text-center pa-4">
                  <div class="text-h2 font-weight-bold orange--text">{{ referralStats.total_referrals || 0 }}</div>
                  <div class="text-subtitle-1 grey--text">Total Referrals</div>
                  <div class="text-caption grey--text">People who used your link</div>
                </div>
              </v-col>
              
          
              <v-col cols="12" sm="6">
                <div class="text-center pa-4">
                  <div class="text-h2 font-weight-bold info--text">{{ referralStats.entry_referrals || 0 }}</div>
                  <div class="text-subtitle-1 grey--text">Entry Purchases</div>
                  <div class="text-caption grey--text">Sweepstakes entries bought</div>
                </div>
              </v-col>
            </v-row>
            
            <v-divider class="my-4"></v-divider>
            
            <div class="text-center">
              <div class="text-h4 font-weight-bold purple--text">${{ formatPrice(referralStats.total_referral_value || 0) }}</div>
              <div class="text-subtitle-1 grey--text">Total Referral Value</div>
              <div class="text-caption grey--text">Value of entries purchased through your referrals</div>
            </div>
          </div>
        </v-card>

        <!-- How It Works -->
        <v-card class="card-shadow border-radius-xl" elevation="4">
          <div class="px-6 py-6">
            <h5 class="text-h5 font-weight-bold text-typo mb-4">
              <v-icon color="info" class="mr-2">mdi-help-circle</v-icon>
              How Referrals Work
            </h5>
            
            <v-row>
              <v-col cols="12" md="4">
                <div class="text-center pa-4">
                  <v-icon size="48" color="orange" class="mb-3">mdi-share</v-icon>
                  <h6 class="text-h6 font-weight-bold mb-2">1. Share Your Link</h6>
                  <p class="text-body-2 grey--text">Copy and share your unique referral link with friends and family</p>
                </div>
              </v-col>
              
              <v-col cols="12" md="4">
                <div class="text-center pa-4">
                  <v-icon size="48" color="success" class="mb-3">mdi-account-plus</v-icon>
                  <h6 class="text-h6 font-weight-bold mb-2">2. They Take Action</h6>
                  <p class="text-body-2 grey--text">When someone uses your link to sign up or enter sweepstakes, you get credit</p>
                </div>
              </v-col>
              
              <v-col cols="12" md="4">
                <div class="text-center pa-4">
                  <v-icon size="48" color="purple" class="mb-3">mdi-gift</v-icon>
                  <h6 class="text-h6 font-weight-bold mb-2">3. Earn Rewards</h6>
                  <p class="text-body-2 grey--text">Get bonus entries and other rewards for successful referrals</p>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>

      </v-container>
    </v-main>
    <vue-footer></vue-footer>
  </v-app>
</template>

<script>
export default {
  name: 'MyReferrals',
  data() {
    return {
      loading: false,
      referralLink: '',
      referralStats: {
        total_referrals: 0,
        signup_referrals: 0,
        entry_referrals: 0,
        total_referral_value: 0
      }
    }
  },
  
  async created() {
    await this.loadReferralInfo()
  },
  
  methods: {
    async loadReferralInfo() {
      try {
        this.loading = true
        const response = await axios.get('/api/sweepstakes-admin/referrals/user', {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          },
          params: {
            user_id: this.getCurrentUserId()
          }
        })

        if (response.data.flag === 1) {
          const info = response.data.referral_info
          this.referralLink = info.referral_link
          this.referralStats = {
            total_referrals: info.total_referrals,
            signup_referrals: info.signup_referrals,
            entry_referrals: info.entry_referrals,
            total_referral_value: info.total_entry_value
          }
        }
      } catch (error) {
        console.error('Error loading referral info:', error)
        this.$toast.error('Failed to load referral information')
      } finally {
        this.loading = false
      }
    },

    getCurrentUserId() {
      // Get user ID from localStorage or JWT token
      const token = localStorage.getItem('token')
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1]))
          return payload.sub || payload.user_id
        } catch (e) {
          console.error('Error parsing token:', e)
        }
      }
      return null
    },

    copyReferralLink() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.referralLink).then(() => {
          this.$toast.success('Referral link copied to clipboard!', {
            position: 'top-right'
          })
        })
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea')
        textArea.value = this.referralLink
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
        this.$toast.success('Referral link copied to clipboard!', {
          position: 'top-right'
        })
      }
    },

    shareOnFacebook() {
      const url = encodeURIComponent(this.referralLink)
      const text = encodeURIComponent('Join me on this amazing sweepstakes platform!')
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${text}`, '_blank')
    },

    shareOnTwitter() {
      const url = encodeURIComponent(this.referralLink)
      const text = encodeURIComponent('Join me on this amazing sweepstakes platform!')
      window.open(`https://twitter.com/intent/tweet?url=${url}&text=${text}`, '_blank')
    },

    shareViaSMS() {
      const text = encodeURIComponent(`Join me on this amazing sweepstakes platform! ${this.referralLink}`)
      window.open(`sms:?body=${text}`, '_blank')
    },

    shareViaEmail() {
      const subject = encodeURIComponent('Join me on this amazing sweepstakes!')
      const body = encodeURIComponent(`Hi! I wanted to share this amazing sweepstakes platform with you. Join using my referral link: ${this.referralLink}`)
      window.open(`mailto:?subject=${subject}&body=${body}`, '_blank')
    },

    formatPrice(value) {
      if (!value) return '0.00'
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value)
    }
  }
}
</script>

<style scoped>
.card-shadow {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.border-radius-xl {
  border-radius: 1rem;
}

.text-typo {
  color: #344767;
}
</style>
